import omitBy from 'lodash-es/omitBy'
import pickBy from 'lodash-es/pickBy'
import keys from 'lodash-es/keys'

export function graphqlPatch<T extends Object>(obj: T): T | Partial<T> {
  return omitBy(obj, v => {
    if (typeof v === 'string') return v === ''
    return v === null
  }) || {}
}

// Turns { a: 'a', b: '', c: null } into ['b', 'c']
export function graphqlDelete<T extends Object>(obj: T): (keyof T)[] {
  const deleteKeys = keys(pickBy(obj, v => {
    if (typeof v === 'string') return v === ''
    return v === null
  })) as (keyof T)[]
  return deleteKeys || []
}
